import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Select, { components }  from 'react-select';
import {sharedLabelsPath} from "../../../reducers/common/localization";
import {Popover, PopoverBody} from 'reactstrap';
import _ from 'lodash';
import './CustomSelect.css';
import uuid from 'uuid';

export const STATUSES = {
    ERROR: 'error',
    WARNING: 'warning',
    INFO: 'info',
    SUCCESS: 'success'
};

export const COLOR_BY_STATUS = {
    [STATUSES.ERROR]: 'red',
    [STATUSES.WARNING]: 'orange',
    [STATUSES.INFO]: '#5f9fff',
    [STATUSES.SUCCESS]: 'greenyellow'
};

const customStyles = {
    control: (styles, state) => ({
        ...styles,
        borderColor: !state.selectProps.status && state.isFocused ? '#80bdff' : '#ced4da',
        boxShadow: !state.selectProps.status && state.isFocused ? '0 0 0 0.2rem rgba(0,123,255,.25)' : 'none',
        lineHeight: '1',
        cursor: 'pointer',
        border: state.selectProps.status ? '2px solid ' + COLOR_BY_STATUS[state.selectProps.status] : '1px solid #ced4da',
        ":hover": {
            border: state.selectProps.status ? '2px solid ' + COLOR_BY_STATUS[state.selectProps.status] : '1px solid #ced4da',
        },
        margin: state.selectProps.status ? '-1px' : 0
    }),
    valueContainer: (styles, state) => ({
        ...styles,
        padding: '.375rem .75rem',
        height: state.isMulti ? null : '36px'
    }),
    placeholder: styles => ({
        ...styles,
        color: '#495057',
        marginLeft: '4px',
        marginRight: '2px'
    }),
    clearIndicator: styles => ({
        ...styles,
        padding: '4px',
        cursor: 'pointer'
    }),
    dropdownIndicator: (styles) => ({
        ...styles,
        padding: '4px',
        cursor: 'pointer',
        // padding: '0 5px 0 0'
    }),
    indicatorSeparator: (styles) => ({
        ...styles,
        display: 'none'
        // marginTop: '2px',
        // marginBottom: '2px',
        // backgroundColor: '#ced4da'
    }),
    singleValue: styles => ({
        ...styles,
        height: '21px',
        padding: '3px 0'
    }),
    option: (styles, state) => ({
        ...styles,
        ":hover": {
            backgroundColor: state.isSelected ? '#89aa11' : 'rgba(137, 170, 17, 0.44)'
        },
        backgroundColor: state.isSelected ? '#89aa11' : 'white',
        cursor: 'pointer',
        paddingTop: '0',
        paddingBottom: '0'
    }),
    menu: styles => ({
        ...styles,
        marginTop: '0',
        marginBottom: '0',
        borderRadius: '0',
        zIndex: 1000
    }),
    menuList: styles => ({
        ...styles,
        paddingTop: '0',
        paddingBottom: '0'
    })
};

class Option extends Component {
    render() {
        return <div title={this.props.data.title}><components.Option {...this.props}/></div>;
    }
}

class CustomSelect extends Component {
    constructor(props) {
        super(props);

        this.state = {
            id: uuid()
        }
    }

    render() {
        let id = this.props.id || this.state.id;
        return (
            <div>
                <Select
                    key='select'
                    id={id}
                    styles={this.props.customStyles || customStyles}
                    ref={this.props.innerRef}
                    className={this.props.className}
                    isSearchable={this.props.isSearchable || false}
                    value={this.props.selectedOption || null}
                    onChange={this.props.onSelect}
                    onInputChange={this.props.onInputChange}
                    placeholder={this.props.placeholder}
                    isDisabled={this.props.disabled}
                    options={this.props.options}
                    onFocus={this.props.onFocus}
                    onBlur={this.props.onBlur}
                    status={this.props.status}
                    menuPlacement={this.props.menuPlacement}
                    isMulti={this.props.isMulti}
                    closeMenuOnSelect={this.props.closeMenuOnSelect}
                    components={{Option: Option}}
                    openMenuOnFocus/>
                <Popover
                    className='select-error-popover'
                    key='popover'
                    placement={"bottom"}
                    isOpen={this.props.requiredFieldError && (!this.props.selectedOption || this.props.selectedOption.length === 0)}
                    target={"[id='"+id+"']"}
                >
                    <PopoverBody className="popover-body">
                        {_.get(this.props.translation, sharedLabelsPath.required_field_error_message)}
                    </PopoverBody>
                </Popover>
            </div>
        );
    }

    renderOptions = (value, label) => {
        return <div>Haha {label}</div>
    }
}

CustomSelect.propTypes = {
    id: PropTypes.string,
    innerRef: PropTypes.func,
    className: PropTypes.string,
    selectedOption: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    options: PropTypes.array.isRequired,
    isSearchable: PropTypes.bool,
    placeholder: PropTypes.string,
    disabled: PropTypes.bool,
    status: PropTypes.string,
    requiredFieldError: PropTypes.bool,
    translation: PropTypes.object,
    menuPlacement: PropTypes.string,
    customStyles: PropTypes.object,
    isMulti: PropTypes.bool,
    closeMenuOnSelect: PropTypes.bool,
    onSelect: PropTypes.func.isRequired,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    onInputChange: PropTypes.func
};

export default CustomSelect;



// WEBPACK FOOTER //
// ./src/components/commonComponents/customSelect/CustomSelect.js